import { useState, useEffect } from "react";
import { motion } from "motion/react";
import IconChevron from "@/assets/icons/chevron.svg?react";
import IconDon from "@/assets/icons/don.svg?react";
import IconEye from "@/assets/icons/eye.svg?react";
import IconCloseEye from "@/assets/icons/eye-closed.svg?react";
import DiamondCircleFilled from "@/assets/icons/diamond-circle-linear.svg?react";
import { formatNumber } from "@/shared/utils";
import { useNavigate } from "react-router";
import IconHistory from "@/assets/icons/history.svg?react";
import { useGetProfile } from "@/pages/profile/api";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";
import Image from "@/components/base/Image.tsx";
import defaultImage from "/images/default/user.svg"

const SectionEntrance = () => {
  const [isHidden, setIsHidden] = useState(() => {
    return localStorage.getItem("isHidden") === "true" || false;
  });

  useEffect(() => {
    localStorage.setItem("isHidden", String(isHidden));
  }, [isHidden]);
  const { data: profile } = useGetProfile();
  const navigate = useNavigate();

  return (
    <div className="relative flex items-end min-h-[197px] pb-4 z-10">
      <div className="container relative z-20 flex items-end justify-between">
        <div className="flex flex-col gap-1 ">
          <VibratingButton
            onClick={() => navigate(`/profile`)}
            className="flex-y-center cursor-pointer group gap-1"
          >
            <div className="w-6 h-6 rounded-full border border-white/20 p-px overflow-hidden">
              {profile?.avatar ? <Image
                wrapperClassName="rounded-full overflow-hidden"
                imgClassName="rounded-full w-full h-full object-cover"
                size="medium"
                urls={profile.avatar}
                fallback={defaultImage}
                alt={profile?.full_name ?? ""}
              /> : (
                <img className='rounded-full' src={defaultImage} alt='profile avatar' />
              )}
            </div>
            <p className="text-xs font-normal leading-130 text-white F">
              {profile?.username ?? profile?.full_name}
            </p>
            <div className="flex items-center mt-[1px]">
              {profile?.is_premium && (
                <DiamondCircleFilled className="size-4" />
              )}
              <IconChevron className="text-gray-1 w-5 h-5" strokeWidth="1.5" />
            </div>
          </VibratingButton>
          <div className="flex-y-center h-8">
            <IconDon width="28" height="28" className="text-gray-1 mr-1" />
            <motion.div
              className="flex gap-1"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              key={`${isHidden}`}
            >
              {isHidden ? (
                Array(6)
                  .fill(null)
                  .map((_, i) => (
                    <div
                      key={i}
                      className="w-1.5 h-1.5 gap-1 bg-white rounded-full"
                    ></div>
                  ))
              ) : (
                <p className="text-[28px] leading-130 font-bold text-white whitespace-pre">
                  {profile?.wallet_amount &&
                    formatNumber(profile.wallet_amount)}
                </p>
              )}
            </motion.div>
          </div>
        </div>
        <div className="flex gap-2.5">
          <VibratingButton
            vibrationType="heavy"
            onClick={() => setIsHidden(!isHidden)}
            className="w-10 h-10 flex-center rounded-full bg-white/08 backdrop-blur-[10px] active:scale-90 transition-200"
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.2 }}
              key={`${isHidden}`}
            >
              {isHidden ? (
                <IconCloseEye
                  width="28"
                  height="28"
                  strokeWidth="2"
                  className="text-white"
                />
              ) : (
                <IconEye
                  width="28"
                  height="28"
                  strokeWidth="2"
                  className="text-white"
                />
              )}
            </motion.div>
          </VibratingButton>
          <VibratingButton
            onClick={() => navigate(`/history`)}
            className="w-10 h-10 flex-center rounded-full bg-white/08 backdrop-blur-[10px] active:scale-90 transition-200"
          >
            <IconHistory width="24" height="24" />
          </VibratingButton>
        </div>
      </div>
      <img
        className="h-[273px] aspect-[191/273] absolute z-10 right-0 top-1/2 -translate-y-1/2"
        src="images/patterns/entrance.webp"
        alt=""
      />
      <div className="absolute z-10 left-0 right-0 top-0 h-[105px] bg-[linear-gradient(180deg,_#0E0E14_0%,_rgba(14,_14,_20,_0)_100%)]" />
    </div>
  );
};

export default SectionEntrance;
